const MEIQIA_PLANS = [1, 2, 3, 4, 9];

const MEIQIA_PLAN_LIST = [
  { value: -1, text: '试用版' },
  { value: 1, text: '体验版' },
  // { value: 2, text: '标准版' },
  { value: 3, text: '专业版' },
  { value: 4, text: '企业版' },
  { value: 9, text: '旗舰版' }
];

const MEIQIA_NEW_PLAN_LIST = [
  { value: 1001, text: '试用版' },
  { value: 1002, text: '体验版' },
  { value: 1003, text: '专业版' },
  { value: 1004, text: '企业版' },
  { value: 1005, text: '旗舰版' }
];

const ROBOT_PLAN_LIST = [
  { value: 1201, text: '试用版' },
  { value: 1203, text: '专业版' },
  { value: 1204, text: '企业版' },
  { value: 1205, text: '旗舰版' }
];

const MARKETING_ROBOT_PLAN_LIST = [
  { value: 1101, text: '体验版' },
  { value: 1102, text: '试用版' },
  { value: 1103, text: '专业版' },
  { value: 1104, text: '企业版' },
  { value: 1105, text: '旗舰版' }
];

const TICKET_PLAN_LIST = [
  { value: 1501, text: '试用版' },
  { value: 1502, text: '免费版' },
  { value: 1503, text: '专业版' }
];

const PUSH_PLAN_LIST = [{ value: 1310, text: '默认版本' }];

const ROBOT_CALL_LIST = [
  {
    value: 1601,
    text: '默认版本'
  }
];

const CAFE_MEIQIA_VERSION = [
  {
    code: 'spec_code_100',
    name: '体验版'
  },
  {
    code: 'spec_code_200',
    name: '试用版'
  },
  {
    code: 'spec_code_300',
    name: '专业版'
  },
  {
    code: 'spec_code_400',
    name: '企业版'
  },
  {
    code: 'spec_code_500',
    name: '旗舰版'
  },
  {
    code: 'spec_code_600',
    name: '定制版'
  }
];

export default {
  MEIQIA_PLANS,
  MEIQIA_PLAN_LIST,
  MEIQIA_NEW_PLAN_LIST,
  ROBOT_PLAN_LIST,
  MARKETING_ROBOT_PLAN_LIST,
  PUSH_PLAN_LIST,
  TICKET_PLAN_LIST,
  ROBOT_CALL_LIST,
  CAFE_MEIQIA_VERSION
};
